import React, { useCallback, useState } from 'react';
import { toast } from 'react-toastify';
import { useObservable } from 'react-use-observable';

import RegistryBlockModal from 'v2/components/RegistryBlockModal';
import useGetPermissions from 'v2/hooks/useGetPermissions';
import { useRegistryCheck } from 'v2/hooks/useRegistryCheck';
import eduzzAccountsService from 'v2/services/eduzzAccount';

import { Icon } from '@eduzz/ui-antd-theme';
import { Topbar } from '@eduzz/ui-layout';

const NoPartner = () => {
  const [user] = useObservable(() => eduzzAccountsService.getUser(), []);
  const permissions = useGetPermissions();
  const { data: registryCheck } = useRegistryCheck();

  const [showRegistryBlockModal, setShowRegistryBlockModal] = useState(false);

  const handleClick = useCallback(() => {
    if (user?.cannot_become_partner) {
      toast.error('Você já possui uma conta parceira ou ligada a um produto na Eduzz!');
      return;
    }

    setShowRegistryBlockModal(true);
  }, [user?.cannot_become_partner]);

  const handleCancelRegistryBlockModal = useCallback(() => {
    setShowRegistryBlockModal(false);
    window.location.href = '/';
  }, []);

  return (
    <>
      <Topbar.Action icon={<Icon.Zap />} label='Quero Vender' onClick={handleClick} />
      <RegistryBlockModal
        opened={showRegistryBlockModal}
        isOwner={permissions?.owned}
        cancelable={registryCheck?.skip}
        onCancel={handleCancelRegistryBlockModal}
        hideCancelButton={true}
        redirectTo={encodeURIComponent(`${window.location.origin}/producer/dashboard?from=registry`)}
      />
    </>
  );
};

export default NoPartner;
